{
  "adobeExperienceCloudNoOrgsSelect": "Select another org account",
  "help": "Help",
  "newAnnouncement": "Has new announcement",
  "notification": "Notifications and Announcements",
  "profile": "Profile",
  "searchButton": "Search",
  "sidenavMenuCloseTooltip": "Close menu",
  "sidenavMenuOpenTooltip": "Open menu",
  "solutionSwitcher": "Switch to another Solution",
  "unread": "unread notifications"
} 
